<template>
  <div class="detail_page">
    <el-tabs v-model="pageIndex" class="tabs-container">
      <el-tab-pane
        :label="$t('zlfk.jbxx')"
        name="problemDetailTab"
      ></el-tab-pane>
      <el-tab-pane
        v-if="problemData.regionalManageReview === 1"
        :label="$t('zlfk.yjcs')"
        name="emergencyMeasureTab"
      ></el-tab-pane>
      <el-tab-pane :label="$t('zlfk.cljl')" name="dealInfoTab"></el-tab-pane>
    </el-tabs>
    <div class="contentInfo">
      <div v-show="pageIndex === 'problemDetailTab'">
        <!-- 基本信息 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/basicRed.png" alt="dark" />
              {{ $t("zlfk.jbxx") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions class="desc-container" :column="3" border>
            <!-- 问题序号 -->
            <el-descriptions-item :label="$t('zlfk.wtbh')">
              {{ problemData.questionNum }}
            </el-descriptions-item>
              <!-- 车型 -->
              <el-descriptions-item :label="$t('home.carType')">
                {{ problemData.carModel }}
              </el-descriptions-item>
              <!-- 车辆类型 -->
              <el-descriptions-item :label="$t('zlfk.clsx')">
                {{
                  problemData.carAttribute === 0
                    ? $t("climant.ryc")
                    : $t("climant.ddc")
                }}
              </el-descriptions-item>
              <!-- 故障发生日期 -->
              <el-descriptions-item :label="$t('zlfk.gzfsrq')">
                {{ problemData.happenDate }}
              </el-descriptions-item>
              <!-- 故障发生地点 -->
              <el-descriptions-item :label="$t('zlfk.gzfsdd')">
                {{ problemData.happenPlace }}
              </el-descriptions-item>
              <!-- 报修日期 -->
              <el-descriptions-item :label="$t('seek.warrantyDate')">
                {{ problemData.repairDate }}
              </el-descriptions-item>
              <!-- 严重程度 -->
              <el-descriptions-item
                :label="$t('restockInfo.yzcd')"
                label-class-name="custom-label"
              >
                {{ problemData.severityLevel }}
              </el-descriptions-item>
              <!-- 是否重点问题 -->
              <el-descriptions-item
                :label="$t('zlfk.sfzdwt')"
                label-class-name="custom-label"
              >
                {{
                  problemData.importantType == 1
                    ? $t("seek.yes")
                    : $t("seek.no")
                }}
              </el-descriptions-item>
              <!-- 重点问题描述 -->
              <el-descriptions-item
                :label="$t('zlfk.zdwtms')"
                label-class-name="custom-label"
                v-if="problemData.importantType === 1"
              >
                {{ problemData.importantDescribe }}
              </el-descriptions-item>
              <!-- 是否有维修措施 -->
              <el-descriptions-item
                :label="$t('zlfk.sfywxcs')"
                label-class-name="custom-label"
              >
                {{
                  problemData.serviceMeasure == 1
                    ? $t("seek.yes")
                    : $t("seek.no")
                }}
              </el-descriptions-item>
              <!-- 市场维修措施 -->
              <el-descriptions-item
                v-if="problemData.serviceMeasure == 1"
                :label="$t('restockInfo.cswxcs')"
                label-class-name="custom-label"
              >
                {{ problemData.marketService }}
              </el-descriptions-item>
              <!-- 生产订单号 -->
              <el-descriptions-item :label="$t('zlfk.scddh')">
                {{ problemData.orderNum }}
              </el-descriptions-item>
              <!-- 订单车辆数量 -->
              <el-descriptions-item :label="$t('zlfk.ddclsl')">
                {{ problemData.carTotal }}
              </el-descriptions-item>

              <!-- 故障车数量 -->
              <el-descriptions-item
                :label="$t('zlfk.gzcsl')"
                label-class-name="custom-label"
              >
                {{ problemData.badCarTotal }}
              </el-descriptions-item>
              <!-- 故障车VIN码 -->
              <el-descriptions-item :label="$t('zlfk.gzcvin')">
                <span @click="handleLookAllVin" class="lineTheme">{{
                  $t("operate.view")
                }}</span>
              </el-descriptions-item>
              <!-- 零部件类别 -->
              <el-descriptions-item
                :label="$t('zlfk.lztype')"
                label-class-name="custom-label"
              >
                <div
                  v-for="(item, index) in componentCategoryList"
                  :key="index"
                >
                  <div v-if="item.code == problemData.componentCategory">
                    {{ item[componentCategoryName.get($i18n.locale)] }}
                  </div>
                </div>
              </el-descriptions-item>
              <!-- 零部件批次信息 -->
              <el-descriptions-item :label="$t('zlfk.lzpcinfo')">
                {{ problemData.componentBatchs }}
              </el-descriptions-item>
              <!-- 故障数量 -->
              <el-descriptions-item
                :label="$t('zlfk.gznum')"
                label-class-name="custom-label"
              >
                {{ problemData.faultNumber }}
              </el-descriptions-item>
              <!-- 疑似/祸首件代码 -->
              <el-descriptions-item :label="$t('seek.culpritCode')">
                {{ problemData.suspectPartNumber }}
              </el-descriptions-item>
              <!-- 疑似/祸首件名称 -->
              <el-descriptions-item :label="$t('seek.culpritName')">
                {{ problemData.suspectPartName }}
              </el-descriptions-item>
              <!-- 供应商代码/名称 -->
              <!-- <el-descriptions-item :label="$t('restockInfo.supplierInfo')">
                {{ problemData.supplierInfo }}
              </el-descriptions-item> -->
            </el-descriptions>
          </div>
        </div>

        <!-- 问题描述 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/wtmsred.png" alt="" />
              {{ $t("zlfk.wtms") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions class="desc-container" :column="3" border>
              <!-- 故障描述 -->
              <el-descriptions-item :label="$t('restockInfo.gzxxms')" :span="2">
                {{ problemData.questionContent }}
              </el-descriptions-item>
              <!-- 重复性 -->
              <el-descriptions-item :label="$t('restockInfo.cfx')" :span="2">
                {{
                  problemData.repeatability == 0
                    ? $t("restockInfo.exist")
                    : $t("restockInfo.occasional")
                }}
              </el-descriptions-item>
              <!-- 附件 -->
              <!-- <el-descriptions-item :label="$t('zlfk.fj')" :span="6">
                <file-upload-list ref="fileUploadList" :fileList="problemData.faultCommonFiles"></file-upload-list>
              </el-descriptions-item> -->
            </el-descriptions>
          </div>
        </div>
        <!-- 图片和视频 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/imgRed.png" alt="" />
              {{ $t("restockInfo.imgVideo") }}
            </div>
          </div>
          <div class="form-container">
            <el-descriptions class="desc-container" :column="1" border>
              <!-- 故障视频/图片 -->
              <el-descriptions-item :label="$t('restockInfo.gzTitle')">
                <file-upload-list
                  ref="fileUploadList"
                  :fileList="problemData.faultVideoFiles"
                ></file-upload-list>
              </el-descriptions-item>
              <!-- 故障代码 -->
              <el-descriptions-item
                :label="$t('restockInfo.gzcode')"
                v-bind="descContentClass"
              >
                <div :class="getRemarkClass(problemData.faultCodeRemark)">
                  {{ problemData.faultCodeRemark }}
                </div>
                <file-upload-list
                  ref="fileUploadList"
                  v-if="problemData.faultCodeFiles.length > 0"
                  :fileList="problemData.faultCodeFiles"
                ></file-upload-list>
              </el-descriptions-item>
              <!-- 其他说明 -->
              <el-descriptions-item
                :label="$t('restockInfo.otherInfo')"
                v-bind="descContentClass"
              >
                <div :class="getRemarkClass(problemData.otherRemark)">
                  {{ problemData.otherRemark }}
                </div>
                <file-upload-list
                  ref="fileUploadList"
                  v-if="problemData.otherFiles.length > 0"
                  :fileList="problemData.otherFiles"
                ></file-upload-list>
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
        <!-- 临时措施 -->
        <div>
          <div class="hearder-title">
            <div class="flex_between">
              <img src="@/assets/image/interimMeasure.png" alt="" />
              {{ $t("zlfk.temporary") }}
            </div>
          </div>
          <div>
            <el-descriptions class="desc-container" :column="1" border>
              <!-- 临时措施 -->
              <el-descriptions-item :label="$t('zlfk.temporary')">
                {{ provisionalMeasures }}
              </el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
      <div v-show="pageIndex === 'emergencyMeasureTab'">
        <emergency-measure :problemData="problemData" />
      </div>
      <div v-show="pageIndex === 'dealInfoTab'">
        <audit-record :recordList="recordList"/>
      </div>
      <!-- 问题编辑修改组件 -->
      <pre-problem-dialog
        ref="preProblemDialog"
        :carTypeList="carTypeList"
        @success="getDetail"
      />
      <!-- 审核组件 -->
      <audit-dialog ref="auditDialog" @success="getDetail" />
      <!-- vin列表 -->
      <vin-list-dialog ref="vinListDialog" />
    </div>
    <div class="footer-button">
      <el-button
        v-if="problemData.status === 0 || problemData.status === 3"
        class="primary-btn lang-but"
        type="primary"
        @click="handleEdit()"
      >{{ $t("zlfk.bjwt") }}</el-button>
      <el-button
        v-if="problemData.status === 2"
        class="primary-btn lang-but"
        type="primary"
        @click="handleExamine('approval', true, 'accept')"
        >{{ $t("home.confirm") }}</el-button
      >
<!--      <el-button-->
<!--        v-if="problemData.status === 2"-->
<!--        class="lang-but"-->
<!--        type="danger"-->
<!--        @click="handleExamine('approval', false, 'disagree')"-->
<!--        >{{ $t("message.bh") }}</el-button-->
<!--      >-->
      <el-button
        v-if="problemData.status === 3"
        plain
        class="primary-btn lang-but"
        type="primary"
        @click="handelCancel"
      >{{ $t("seek.cancel") }}</el-button>

      <!-- <el-button class="primary-btn" type="primary" @click="back">{{
          $t("operate.backList")
        }}</el-button> -->
    </div>
  </div>
</template>
<script>
import { getStorage, setStorageNew } from "@/util/localStor";
import { getDictItem } from "@/util/dict";
import { preAfterSalesQuestionListApi, auditHistoryList } from "@/api/feedback";
import AuditRecord from "./auditRecord.vue";
import EmergencyMeasure from "./emergencyMeasure.vue";
import PreProblemDialog from "./preProblemDialog.vue";
import AuditDialog from "./auditDialog.vue";
import VinListDialog from "./vinListDialog.vue";
import TranslateBtn from "@/components/translateBtn.vue";
import faultData from "@/mixins/faultData";
export default {
  components: {
    AuditRecord,
    EmergencyMeasure,
    PreProblemDialog,
    AuditDialog,
    VinListDialog,
    TranslateBtn,
  },
  mixins: [faultData],
  data() {
    return {
      carTypeList: [], //车型
      qualityData: {}, // 反馈单数据
      problemData: {}, // 问题数据
      pageIndex: "problemDetailTab", // 详情 | 记录
      provisionalMeasures: "",
      pageName: "zlfk.ckfkd",
      recordList: [],
    };
  },
  watch: {
    "$i18n.locale"() {
      this.getInitializeInfo();
    }
  },
  async created() {
    this.getInitializeInfo();
  },
  computed: {
    // 图片视频内容className
    descContentClass() {
      return {
        contentClassName: "content-input",
      };
    },
  },
  methods: {
    getInitializeInfo() {
      // 获取车型列表
      this.getCarTypeList();
      // 反馈单数据
      this.qualityData = getStorage("qualityData");
      // 问题数据
      this.problemData = getStorage("problemData");
      this.problemData.faultCommonFiles = this.convertArrayData(
        this.problemData.faultCommonFiles
      );
      this.problemData.faultVideoFiles = this.convertArrayData(
        this.problemData.faultVideoFiles
      );
      this.problemData.faultCodeFiles = this.convertArrayData(
        this.problemData.faultCodeFiles
      );
      this.problemData.otherFiles = this.convertArrayData(
        this.problemData.otherFiles
      );
      this.getTypeList();
      this.sizeArea();
      this.getMeasureDetail();
      this.getMetaData();
    },
    // 返回上一步
    getMetaData() {
      if (sessionStorage.getItem("goBackPath")) {
        this.$route.meta.father = this.pageName;
        this.$route.meta.fatherPath = sessionStorage.getItem("goBackPath");
      }
    },
    back() {
      this.$router.go(-1);
      // this.$refs.auditDialog.init("11", "22", "examineParams", "disagree");
    },
    // 备注className
    getRemarkClass(item) {
      return item?.length ? "remarkInfo" : "";
    },
    // 获取临时措施
    async getMeasureDetail() {
      const res = await auditHistoryList({
        data: { questionId: this.problemData.questionId },
      });
      this.recordList = res.data;
      this.recordList.forEach((item) => {
        if (item.provisionalMeasures) {
          this.provisionalMeasures = item.provisionalMeasures;
        }
      });
    },
    // 获取车型列表
    async getCarTypeList() {
      try {
        const carTypeList = (await getDictItem('carType')) || []
        carTypeList.map((item) => {
          this.carTypeList.push({ text: item.value, value: item.code })
        })
      } catch (error) {
        console.error("获取车辆类型失败:", error);
      }
    },
    // 详情 | 记录
    handleViewRecord(index) {
      this.pageIndex = index;
    },
    //  编辑问题
    handleEdit() {
      this.$refs.preProblemDialog.init(this.$t("zlfk.bjwt"), this.problemData);
    },
    // 审核问题
    handleExamine(field, value, dialogType) {
      var examineParams = {
        ...this.problemData,
        variables: {},
      };
      var title = "";
      var examineTip = `${this.$t("zlfk.wt")} ${examineParams.questionNum} `;
      examineParams.variables[field] = value;
      // 通过驳回
      if (field === "approval") {
        title = value ? "通过" : this.$t("message.bh");
        examineTip =
          examineTip +
          (value ? this.$t("home.passed") : this.$t("climant.rejected"));
        if (dialogType === "accept") {
          title = this.$t("zlfk.rk");
          examineTip = `${this.$t("zlfk.wt")} ${
            examineParams.questionNum
          } ${this.$t("zlfk.yrk")}`;
        }
        console.log(title, examineTip);
      }
      this.$refs.auditDialog.init(title, examineTip, examineParams, dialogType);
    },
    handelCancel(){
      this.getDealerCancel();
    },
    // 获取问题详情
    async getDetail() {
      const res = await preAfterSalesQuestionListApi({
        data: {
          feedbackFormId: this.problemData.feedbackFormId,
          questionNum: this.problemData.questionNum,
        },
        page: {
          pageNum: 1,
          pageSize: 1,
        },
      });
      this.problemData = { ...res.data?.records[0] };
      setStorageNew("problemData", this.problemData);
    },
    // 查看全部vin码
    handleLookAllVin() {
      this.$refs.vinListDialog.init(this.problemData.vinCheckRespList);
    },
    // 内容高度
    heightSize() {
      setTimeout(() => {
        var allHeight = $(".detail_page").height();
        var tabHeight = $(".tabs-container").outerHeight(true);
        var footerHeight =
          $(".footer-button")?.length > 0
            ? $(".footer-button").outerHeight(true)
            : 0;
        const val = allHeight - tabHeight - footerHeight;
        $(".contentInfo").css("height", val);
      }, 100);
    },
    sizeArea() {
      var _this = this;
      _this.heightSize();
      window.addEventListener("resize", function () {
        _this.heightSize();
      });
    },
  },
};
</script>
